module.exports = __webpack_public_path__ + "static/pifoam_logo-5e3fd7b0931b6dece19aa8e50fb1a488.svg";